<!-- fallow-ignore-file complexity -->
<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="dialog__content">
  @if (isLoading) {
    <mds-loader loadingText="Loading form..."></mds-loader>
  }
  @if (schemaInput) {
    <div
      mdsInlineFormSchema
      [schema]="schemaInput"
      [lines]="schemaInput.lines"
      (formValueChanged)="onFormValueChanged($event)"
      class="dialog__form"
    ></div>
  }
  @if (validationErrors.length) {
    <div class="dialog__errors" role="alert">
      <div class="dialog__errors-title">Please fix the following errors:</div>
      <ul class="dialog__errors-list">
        @for (err of validationErrors; track err.field) {
          <li><strong>{{ err.label }}:</strong> {{ err.message }}</li>
        }
      </ul>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <mds-button
    (click)="testConnection()"
    [disabled]="isTesting || !isFormValid"
    type="secondary"
    aria-label="Test Connection"
  >
    {{ isTesting ? 'Testing...' : 'Test Connection' }}
  </mds-button>
  @if (testResult) {
    <span class="dialog__test-result" [class.dialog__test-result--success]="testResult.success" [class.dialog__test-result--error]="!testResult.success">
      {{ testResult.success ? 'Connected' : testResult.message }}
    </span>
  }
  <span class="dialog__spacer"></span>
  <mds-button (click)="cancel()" type="secondary" aria-label="Cancel">Cancel</mds-button>
  <mds-button
    (click)="submit()"
    [disabled]="isLoading || !isFormValid || isSubmitting"
    type="primary"
    aria-label="Save"
  >
    {{ isSubmitting ? 'Saving...' : (isEditMode ? 'Update' : 'Create') }}
  </mds-button>
</mat-dialog-actions>
